<template lang="pug">
  div.route-schedule
    div.toolbar.toolbar--big.toolbar--bordered
      div.line
        h1.title Март
        div.view-panel
          button.view-panel__button.view-table
          button.view-panel__button.view-chart.active

    div.content
      .switch
        button.prev
        button.next

      .route-schedule-field
        .route-schedule-field__line
          .route-schedule-text
          .route-schedule-text 21 марта
          .route-schedule-text 22 марта
          .route-schedule-text 23 марта
          .route-schedule-text 24 марта
          .route-schedule-text 25 марта
          .route-schedule-text 26 марта
          .route-schedule-text 27 марта

        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block(@click="showModalSmallAddGarb = !showModalSmallAddGarb")
          .route-schedule-block.route-schedule-block--red
          .route-schedule-block.route-schedule-block--green Мусоровоз №1
          .route-schedule-block.route-schedule-block--green
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block
          .route-schedule-block

        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--green Мусоровоз №1
          .route-schedule-block
          .route-schedule-block
          .route-schedule-block
        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block
          .route-schedule-block

        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block
          .route-schedule-block.route-schedule-block--red
          .route-schedule-block
          .route-schedule-block.route-schedule-block--green Мусоровоз №1
          .route-schedule-block
          .route-schedule-block.route-schedule-block--green
        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--green Мусоровоз №1
          .route-schedule-block
          .route-schedule-block
          .route-schedule-block
        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block
          .route-schedule-block


        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block
          .route-schedule-block.route-schedule-block--red
          .route-schedule-block
          .route-schedule-block.route-schedule-block--green Мусоровоз №1
          .route-schedule-block
          .route-schedule-block.route-schedule-block--green
        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--green Мусоровоз №1
          .route-schedule-block
          .route-schedule-block
          .route-schedule-block
        .route-schedule-field__line
          .route-schedule-text Маршрут №12
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block
          .route-schedule-block.route-schedule-block--transp
          .route-schedule-block
          .route-schedule-block

    transition(name="fade")
      div.smallModal(:class="showModalSmallAddGarb ? 'open' : 'close'")
        div.fixed-overlay.fixed-overlay__modal
          div.modal
            div.modal_container
              div.header
                span.close(@click="showModalSmallAddGarb = !showModalSmallAddGarb")
                h1.title Назначить мусоровоз на <br> маршрут №12
                div.route-info
                  label Приблизительная длительность маршрута:
                  span 3ч 45 мин
                div.route-info
                  label Требуемая вместимость мусоровоза:
                  span >30 т

                //div.tabs
                  span(@click="tabViewSmall = 'tab1'" :class="activeClassSmall('tab1')") Тип объекта
                  span(@click="tabViewSmall = 'tab2'" :class="activeClassSmall('tab2')") Выбор объектов
              div.body-wrapper.cuscroll
                div
                  //slot
                  div.body.body--noPadding
                    div.col
                      div.col-block
                        div.table.table--thin
                          table#zakaz-table
                            thead
                              th Подходящие мусоровозы
                              th

                            tbody
                              tr
                                td Мусоровоз №1
                                td
                              tr
                                td Мусоровоз №1
                                td
                              tr.inactive
                                td Мусоровоз №1
                                td Ремонт
                              tr.inactive
                                td Мусоровоз №1
                                td Ремонт

              div.footer
                div.set-date
                  label Доступное время мусоровоза №1
                  div.set-date-field

                    .date-field.date-field--unavailable(style="width: 80px; left: 0")
                    .date-field.date-field--period(style="width: 238px; left: 80px")
                    .date-field.date-field--unavailable(style="width: 54px; right: 0")
                    .point-start(style="left: 75px")
                    .point-end(style="right: 44px")
                  div.set-date-time
                    span 8:00
                    span 9:00
                    span 10:00
                    span 11:00
                    span 12:00
                    span 13:00
                    span 14:00
                    span 15:00
                    span 16:00
                    span 17:00

                div.actions-filter-panel.actions-filter-panel--right
                  //button.actions-filter-panel__button.standart.standart-delete( ) Удалить
                  div
                    //button.actions-filter-panel__button.standart.standart-noborder(type="button" @click="showModalSmallAddGarb = !showModalSmallAddGarb") Отмена
                    button.actions-filter-panel__button.standart(type="button"  @click="showModalSmallAddGarb = !showModalSmallAddGarb") Назначить


</template>

<script>
  export default {
    data() {
      return {
        showModalSmallAddGarb: false
      }
    }
  }
</script>

